import { ChangeDetectorRef, Component, ViewChild, inject } from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { Subject, Subscription, filter, finalize, tap } from 'rxjs';
import { RestaurantService } from '../../../shared/services/restaurant/restaurant.service';
import { RolesService } from '../../../shared/services/roles/roles.service';
import { StorageService } from '../../../shared/services/storage/storage.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatIcon } from '@angular/material/icon';
import { QeqPipe } from 'src/app/shared/pipes/qeq-pipe/qeq-pippe.pipe';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { QeqService } from 'src/app/shared/services/qeq/qeq.service';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

import { RestaurantSummaryCardsComponent } from 'src/app/shared/components/restaurant/restaurant-summary-cards/restaurant-summary-cards.component';
import { SummaryCard } from 'src/app/shared/interfaces/restaurant-shared.interface';
import {
  PunchesDataResponse,
  ReservationRecord,
  PunchDataItem,
} from '../../../shared/interfaces/restaurant.interface';

@Component({
  selector: 'app-cook-screen',
  imports: [
    MatButtonModule,
    MatButton,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatSortModule,
    CommonModule,
    MatDialogModule,
    TitleComponent,
    MatIcon,
    QeqPipe,
    LoaderComponent,
    MatPaginatorModule,
    RouterOutlet,
  ],
  templateUrl: './cookbreakfast-screen.component.html',
  styleUrls: [
    './cookbreakfast-screen.component.css',
    '../../../shared/styles/layout.css',
  ],
})
export class CookBreakfastScreenComponent {
  constructor(
    private restaurantService: RestaurantService,
    private rolesService: RolesService,
    private storageService: StorageService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService,
    private qeqService: QeqService,
    private router: Router
  ) {}


  isEditDatePage = false;

  private destroy$ = new Subject<void>();
  private navigationSubscription: Subscription | null = null;
  private subscriptions: Subscription[] = [];
  myroles: any = {}; // Change from array to object

  // Flag to track if QeQ data is loaded
  public qeqDataLoaded = false;

  // Summary cards for the restaurant-summary-cards component
  summaryCards: SummaryCard[] = [];

  // Add dataSource for table data
  dataSource: MatTableDataSource<
    ReservationRecord & {
      date: string;
      is_synced?: boolean;
      has_reservation?: boolean;
      reservation_id?: number | null; // <-- añadimos el id de la reserva asociada
    }
  > = new MatTableDataSource<
    ReservationRecord & {
      date: string;
      is_synced?: boolean;
      has_reservation?: boolean;
      reservation_id?: number | null;
    }
  >();

  // Display columns for table
  displayedColumns: string[] = [
    'users',
    'id-users',
    'diet-date',
    'consumed',
    'status',
    'acciones',
  ];
  private _snackBar = inject(MatSnackBar);

  openSnackBar(message: string) {
    this._snackBar.open(message, 'Cerrar', {
      duration: 5000,
    });
  }

  get isLoading() {
    return this.loaderService.getLoader();
  }

  // LiveAnnouncer for accessibility
  private _liveAnnouncer = inject(LiveAnnouncer);

  @ViewChild(MatSort)
  sort: MatSort = new MatSort();

  // Selected filter (always 'hoy' for cook screen)
  config: any = {
    extra_menus: 0,
  };

  title: string = 'Pantalla de desayunos';
  subtitle: string =
    'Gestiona desayunos consumidos por los empleados';

  loadRoles() {
    // Use the refactored method in RolesService
    const permissions = this.rolesService.getPermissionsForFunctionality(
      'kitchen_screen',
      this.storageService
    );
    if (permissions) {
      this.myroles = permissions;
    } else {
      // console.log(
      //   'No user roles found in storage or no permissions for Comedor'
      // );
    }
  }

  searchText: string = '';

  onSearchChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchText = input.value;

    // For the UI table filtering - only filtering by search text, not by date
    const filterValue = JSON.stringify({
      searchText: this.searchText.toLowerCase(),
    });

    this.dataSource.filter = filterValue;
  }

  // Add variables for statistics
  public reservationStats: {
    num_reservations: number;
    num_pending_reservations?: number;
    num_consumed_reservations?: number;
    total_reservations: number; // R (sin extras)
    total_normal_reservations: number;
  } = {
    num_reservations: 0,
    num_pending_reservations: 0,
    num_consumed_reservations: 0,
    total_reservations: 0,
    total_normal_reservations: 0,
  };

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngOnInit() {
    this.loadRoles();
    this.getConfig();
    this.loadReservationData();
    this.setupNavigationListener();
  }

  setupNavigationListener() {
    // Clean up existing navigation subscription if it exists
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

    // Set up new navigation subscription
    this.navigationSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Check if we're on the cook screen route
        if (this.router.url === '/home/dining/cook-screen') {
          // Check if we're coming from reservation-form
          if (
            event.url === '/home/dining/cook-screen' &&
            event.urlAfterRedirects === '/home/dining/cook-screen' &&
            this.isEditDatePage
          ) {
            // Reload data when returning from reservation-form
            this.loadReservationData();
          }
          this.isEditDatePage = false;
        } else if (this.router.url.includes('/dining/cook-screen/edit-date')) {
          this.isEditDatePage = true;
        } else if (
          this.router.url.includes('/dining/cook-screen/reservation-form')
        ) {
          this.isEditDatePage = true;
        }

        this.cdr.detectChanges();
      });
  }

  ngAfterViewInit() {
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      return item[property];
    };
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.cdr.detectChanges();
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

    // Clean up all subscriptions
    this.subscriptions.forEach((sub) => {
      if (sub) {
        sub.unsubscribe();
      }
    });
  }

  // Get restaurant configuration
  getConfig() {
    const today = new Date();
    const todayApiDate = this.formatDateForApi(new Date(new Date().setDate(new Date().getDate())));

    const configSub = this.restaurantService
      .getRestaurantConfigByDate(todayApiDate)
      .subscribe({
        next: (config) => {
          this.config = config;
        },
        error: (err) => {
          console.error('Error loading restaurant config:', err);
        },
      });

    this.subscriptions.push(configSub);
  }

  // Format date for API (YYYY-MM-DD)
  formatDateForApi(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Format date from YYYY-MM-DDT00:00:00Z or YYYY-MM-DD to DD/MM/YYYY for display
  formatDate(dateString: string): string {
    if (!dateString) return '';

    // Handle date strings with or without time component
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  // Set up filter predicate for searching
  setupFilterPredicateFunction() {
    this.dataSource.filterPredicate = (data, filter) => {
      const filterObj = JSON.parse(filter);
      const searchText = filterObj.searchText.toLowerCase();

      // If no search text, return all results
      if (!searchText) {
        return true;
      }

      // Search in employee name and external ID
      const nameMatch =
        data.employee_name?.toLowerCase().includes(searchText) || false;
      const idMatch =
        data.employee_external_id?.toLowerCase().includes(searchText) || false;

      // Add QeQ data filtering
      let qeqMatch = false;

      // Get cached QeQ data
      const cached = this.qeqService['getQeqFromStorage']?.();

      // Find employee by external_id
      const employeeName =
        cached && cached.data
          ? cached.data.find(
              (u: any) => u.personnelnumber === data.employee_external_id
            )?.name || ''
          : '';

      // Check if QeQ name matches search text
      qeqMatch = employeeName.toLowerCase().includes(searchText);

      return nameMatch || idMatch || qeqMatch;
    };
  }


  loadReservationData() {
    this.loaderService.showLoader();
    const todayApiDate = this.formatDateForApi(new Date(new Date().setDate(new Date().getDate())));
    const body = {
      start_date: todayApiDate,
      end_date: todayApiDate,
      include_breakfast: true,
    };

    const reservationsSub = this.restaurantService
      .getPunchesKitchenData(body)
      .subscribe({
        next: (punchesResp: PunchesDataResponse) => {
          let punches = punchesResp?.data || [];
          punches = punches.sort((a, b) =>
            b.created_at.localeCompare(a.created_at)
          );

          // console.log('Punches fetched:', punches);

          const mappedReservations: (ReservationRecord & {
            is_synced?: boolean;
            created_when?: string;
            has_reservation?: boolean;
            is_extra_punch?: boolean;
            reservation_id?: number | null;
          })[] = punches.map((p: PunchDataItem) => {
            const mealType =
              p.punch_type?.toUpperCase() === 'BREAKFAST'
                ? 'BREAKFAST'
                : 'LUNCH';
            const statusUpper = p.is_eaten
              ? 'EATEN'
              : (p.status || '').toUpperCase() === 'EATEN'
              ? 'EATEN'
              : 'PENDING';

            const reservationsArr = Array.isArray(p.reservations)
              ? p.reservations
              : [];

            // Check if reservation was created today
            const createdDate = new Date(p.created_at);
            const todayStart = new Date();
            todayStart.setHours(0, 0, 0, 0);
            const isCreatedToday = createdDate >= todayStart;

            // If created today, treat as no reservation (extra punch)
            const hasReservation =
              reservationsArr.length > 0 && !isCreatedToday;
            const reservationId = hasReservation
              ? reservationsArr[0]?.id ?? null
              : null;
            const isExtraPunch = !hasReservation;

            return {
              id: p.id,
              employee: p.employee,
              employee_external_id: p.employee_external_id,
              employee_name: p.employee_name,
              date: p.date,
              meal_type: mealType,
              status: statusUpper,
              charge: p.charge,
              punch: null,
              is_deleted: false,
              created_at: p.created_at,
              updated_at: p.synced_at as any,
              created_when: p.created_at,
              is_synced: p.is_synced,
              has_reservation: hasReservation,
              is_extra_punch: isExtraPunch,
              reservation_id: reservationId,
            } as any;
          });

          const activeReservations = mappedReservations.filter(
            (r) => !r.is_deleted
          );

          // Solo hoy y solo desayunos
          const todaysReservations = activeReservations.filter(
            (r) => r.date.split('T')[0] === todayApiDate && r.meal_type === 'BREAKFAST'
          );

          const todayStart = new Date();
          todayStart.setHours(0, 0, 0, 0);

          // Separaciones
          const withReservation = todaysReservations.filter(
            (r) => r.has_reservation
          );
          const extraPunches = todaysReservations.filter(
            (r) => r.is_extra_punch
          );

          // Reservas creadas antes de hoy => aportan a R
          const preDayReservations = withReservation.filter((r) => {
            const createdDate = new Date(
              (r as any)['created_when'] || r.created_at || r.date
            );
            return createdDate < todayStart;
          });

          // Reservas (con reserva) creadas hoy (last‑minute) también se tratan como extras (mantiene lógica previa)
          const sameDayNewReservations = withReservation.filter((r) => {
            const createdDate = new Date(
              (r as any)['created_when'] || r.created_at || r.date
            );
            return createdDate >= todayStart;
          });


          // Tabla: todos los punches de hoy
          const formattedReservations = todaysReservations.map((r) => ({
            ...r,
            date: this.formatDate(r.date),
          }));

          this.dataSource.data = formattedReservations as any;
          this.setupFilterPredicateFunction();
          if (this.sort) this.dataSource.sort = this.sort;


          this.cdr.detectChanges();
          this.loaderService.hideLoader();
        },
        error: (error) => {
          this.loaderService.hideLoader();
          console.error('Error loading punches:', error);
          this.openSnackBar('Error al cargar datos');
        },
      });

    this.subscriptions.push(reservationsSub);
  }

  // Method to view details of a reservation
  viewDetails(id: number) {
    if (id == null) return;
    this.router.navigate(['/home/dining/cook-screen/edit-date', id]);
  }

  // Method to delete a reservation
  deleteSelected(id: number, title: string) {
    //   console.log('Delete reservation', id, title);
  }

  refreshReservations() {
    this.loaderService.showLoader(); // Show loader while refreshing
    const todayDate = this.formatDateForApi(new Date(new Date().setDate(new Date().getDate() - 15)));

    this.restaurantService
      .syncPunchesKitchen(todayDate, todayDate)
      .pipe(
        tap((response) => {}),
        finalize(() => {
          // This will run after the observable completes or errors
          this.loadReservationData();
          this.openSnackBar('Reservas actualizadas correctamente');
        })
      )
      .subscribe({
        error: (error) => {
          console.error('Error refreshing reservations:', error);
          this.openSnackBar('Error al actualizar reservas');
        },
      });
  }
}
